import { useState } from 'react';

interface NewsletterFormProps {
  formAction: string;
}

export default function NewsletterForm({ formAction }: NewsletterFormProps) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }
    try {
      const res = await fetch(formAction, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后再试。');
    }
  };

  return (
    <form onSubmit={handleSubmit} data-readdy-form="" className="flex flex-col sm:flex-row gap-3">
      <input
        type="email"
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="请输入您的邮箱地址"
        required
        className="flex-1 px-4 py-2.5 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
      />
      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="absolute opacity-0 pointer-events-none"
        style={{ position: 'absolute', left: '-9999px' }}
      />
      <button
        type="submit"
        className="px-6 py-2.5 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
      >
        订阅
      </button>
      {status !== 'idle' && (
        <p className={`text-sm mt-2 sm:mt-0 sm:self-center ${status === 'success' ? 'text-green-600' : 'text-red-500'}`}>
          {message}
        </p>
      )}
    </form>
  );
}